var _path, _path2, _path3, _path4, _circle, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDebitIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 105,
    viewBox: "0 0 96 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.253397,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1447 74.6088C17.1447 74.6088 17.6256 71.9525 19.5167 78.1989C21.4077 84.4453 42.7914 98.1165 49.9494 87.0446C57.1074 75.9728 67.2273 88.3968 74.2178 85.074C81.2084 81.7511 82.3157 77.3657 77.1051 66.7989C71.8945 56.2321 84.7118 43.3559 71.9353 35.0779C59.1587 26.7998 69.0498 28.8335 69.0498 28.8335L68.9847 62.6301L51.8821 78.1355L17.1447 74.6088Z",
    fill: "url(#paint0_linear_114_475)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.518059,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8521 41.7136C67.8521 41.7136 66.3666 41.6271 69.6564 40.1535C72.9461 38.6799 78.9846 25.886 72.4452 22.6662C65.9059 19.4464 72.0209 12.9872 69.7321 9.33402C67.4432 5.6808 64.9695 5.36426 59.5398 8.97326C54.11 12.5823 43.635 2.94297 39.9671 10.5947C36.2993 18.2464 42.5295 8.95639 42.5295 8.95639L57.8063 13.7623L67.4411 22.199L67.8521 41.7136Z",
    fill: "url(#paint1_linear_114_475)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50L39.5 40.5L34.5 45.5L27 38",
    stroke: "#EB042E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50H49V44",
    stroke: "#EB042E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.7632,
    cy: 45.3159,
    r: 32.7632,
    stroke: "#EB042E",
    strokeOpacity: 0.4,
    strokeWidth: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5456 12.6279C44.215 12.0397 52.763 14.9196 59.309 20.6339C65.8551 26.3482 69.863 34.4289 70.4512 43.0983C71.0393 51.7677 68.1594 60.3157 62.4451 66.8618C56.7308 73.4078 48.6501 77.4158 39.9807 78.0039",
    stroke: "url(#paint2_linear_114_475)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_114_475",
    x1: 19.7231,
    y1: 42.5482,
    x2: 119.919,
    y2: 79.5942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB042E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB042E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_114_475",
    x1: 49.4801,
    y1: 42.2829,
    x2: 63.4508,
    y2: -15.7225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB042E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB042E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_114_475",
    x1: 41.5395,
    y1: -4.33567,
    x2: 45.8005,
    y2: 129.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB042E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A374E",
    stopOpacity: 0.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitIcon);
export default __webpack_public_path__ + "static/media/debit_icon.d054904aea163f0cda98d1a003ab98de.svg";
export { ForwardRef as ReactComponent };